module.exports = __webpack_public_path__ + "translations/en/changePassword.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/changePassword.json
// module id = ./translations/en/changePassword.json
// module chunks = 1